import { render, staticRenderFns } from "./answerExercises.vue?vue&type=template&id=b838c36e&scoped=true&"
import script from "./answerExercises.vue?vue&type=script&lang=js&"
export * from "./answerExercises.vue?vue&type=script&lang=js&"
import style0 from "./answerExercises.vue?vue&type=style&index=0&id=b838c36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b838c36e",
  null
  
)

export default component.exports